export const AiDashboardTexts = {
  aiHelmetText: 'SEOSpace | AI Visibility',
  title: 'AI Visibility',
  progressText:
    'SEOSpace is checking your AI visibility... This can take a few minutes, up to an hour, depending on your topics and competitors — hang tight!',
  noBrandDetail: 'No Details Found',
  noSourcesFound: 'No Sources Found',
  deleted: 'Deleted',
  comingSoon: 'Coming Soon',
  upgradePageTitle: 'Unlock AI Visibility',
  upgradePageDesc:
    'Upgrade to track how your brand and competitors appear across AI results (ChatGPT, Claude, and more).',
  upgradePageBtn: 'Activate AI Visibility'
};

export const aiDashboardTimelineOptions = [
  { value: 'last_7_days', label: 'Past 7 Days' },
  { value: 'last_28_days', label: 'Last 28 Days' },
  { value: 'last_3_months', label: 'Last 3 Months' },
  { value: 'last_12_months', label: 'Last 12 Months' },
  { value: 'since_seoSpace', label: 'Since using SEOSpace' }
  // { value: 'custom_date', label: 'Custom Date Range' }
];
export const AiDashboardCardsTexts = {
  aiVisibilityScore: 'AI Visibility Score',
  visibilityScoreModels: 'Visibility Score by AI Models',
  yourMainCompetitors: 'Your Main Competitors Visibility',
  TopicVisibility: 'Topic Visibility',
  mostReferenced: 'Most Referenced Sites in This Topic ',
  topPrompts: 'Top Prompts',
  boostTopicVisibility: 'Boost Your Topic Visibility in AI',
  wantBetterAiMentions: 'Want Better AI Mentions? Try These Steps',
  aiModel: 'AI Model',
  visibilityScore: 'Visibility Score',
  notMentioned: 'Not mentioned',
  viewResponse: 'View Response',
  aiVisibilityScoreTooltip:
    'Your AI Visibility Score shows how clearly this page can be read and understood by AI tools. It highlights what’s strong and what needs attention so you can make simple changes that help AI pull the right details from your page.',
  yourMainCompetitorsTooltip:
    'This shows how well your closest competitors show up to AI tools. It gives you a quick read on who stands out and who falls behind.',
  yourMainCompetitorsTopicTooltip:
    'This shows each competitor’s visibility score for this topic, so you can see how they appear in AI tools compared with your brand.',
  TopicVisibilityTooltip:
    'This shows how visible your brand is for each topic across AI tools. It reflects how strongly your brand connects with that topic based on the signals AI can read.',
  mostReferencedTooltip:
    'This lists the sites AI mentions most when looking at this topic. It helps you see which pages shape the topic and where your own page may need stronger coverage.',
  topPromptsTooltip:
    'These are the prompts AI most often uses when talking about this topic. They help you see the questions and angles AI expects, so you can shape your page in a way that fits.'
};

export const DummyAiModalsData = [
  {
    name: 'ChatGPT',
    status: 'Positive',
    value: '95%',
    changePer: 2.1,
    url: 'https://chatgpt.com/' // Placeholder/assumed URL
  },
  {
    name: 'Perplexity',
    status: 'Positive',
    value: '95%',
    changePer: 2.1,
    url: 'www.perplexity.ai' // Placeholder/assumed URL
  },
  {
    name: 'Gemini',
    status: 'Positive',
    value: '88%',
    changePer: 1.7,
    url: 'https://gemini.google.com/' // Placeholder/assumed URL
  },
  {
    name: 'DeepSeek',
    status: 'Mixed',
    value: '85%',
    changePer: 1.3,
    url: 'https://www.deepseek.com/' // Placeholder/assumed URL
  },
  {
    name: 'Copilot',
    status: 'Critical',
    value: '80%',
    changePer: -2.5,
    url: 'https://copilot.microsoft.com/' // Placeholder/assumed URL
  }
];

// Static data structure for the list
export const CompetitorData = [
  {
    name: 'SEOSpace',
    value: '88%',
    url: 'https://seospace.co/' // Placeholder URL for the icon
  },
  {
    name: 'Semrush',
    value: '82%',
    url: 'https://semrush.com/'
  },
  {
    name: 'Writesonic',
    value: '81%',
    url: 'app.writesonic.com'
  },
  {
    name: 'SE Ranking',
    value: '79%',
    url: 'https://seranking.com/'
  }
];

export const TopicVisibilityTexts = {
  desc: 'See how well your brand shows up for each topic in AI tools, and compare your standing with your competitors.',
  searchPlaceHolder: 'Search'
};

export const TopicVisibilityData = [
  {
    topic: 'Squarespace SEO',
    avgTopicVisibility: 80,
    changePer: 2.1,
    lastAssessed: '2025-10-29T10:45:00Z',
    topCompetitors: ['Semrush', 'Writesonic', 'Brooks Running', 'Hoka']
  },
  {
    topic: 'Local SEO Optimization',
    avgTopicVisibility: 72,
    changePer: -1.4,
    lastAssessed: '2025-10-28T15:20:00Z',
    topCompetitors: ['BrightLocal', 'Moz', 'Yext', 'Synup']
  },
  {
    topic: 'AI Content Writing',
    avgTopicVisibility: 88,
    changePer: 3.6,
    lastAssessed: '2025-10-29T09:10:00Z',
    topCompetitors: ['Jasper', 'Copy.ai', 'Writesonic', 'Notion AI']
  },
  {
    topic: 'E-commerce SEO',
    avgTopicVisibility: 64,
    changePer: -0.8,
    lastAssessed: '2025-10-27T18:30:00Z',
    topCompetitors: ['Shopify', 'SEMrush', 'BigCommerce']
  },
  {
    topic: 'Technical SEO Auditing',
    avgTopicVisibility: 91,
    changePer: 1.9,
    lastAssessed: '2025-10-29T08:00:00Z',
    topCompetitors: ['Screaming Frog', 'Sitebulb', 'Ahrefs']
  },
  {
    topic: 'Keyword Tracking & Analysis',
    avgTopicVisibility: 76,
    changePer: 0.5,
    lastAssessed: '2025-10-28T13:45:00Z',
    topCompetitors: ['Rank Tracker', 'AccuRanker']
  }
];

export const TotalVisibilityTableTooltipTexts = [
  'Topics - Shows the topics you added for your brand and how AI tools respond to them.',
  'Avg Topic Visibility - Average visibility score of your topics compared to competitors.',
  'Last assessed - The date we last checked this topic in AI tools.',
  'Top Competitors - Brands you added that also appear in the same topics you selected.'
];

export const AiModelAnalysisTexts = {
  siteAudit: 'Site Audit',
  aiVisibility: 'AI Visibility',
  topicAnalysisMetrics: 'Topic Analysis & Metrics',
  aiVisibilityTutorial: 'AI Visibility Tutorial',
  desc: 'Analyze topics performance, visibility, and sentiment across AI models. Use filters to refine your view by region or AI engine.',
  scoreDesc: 'Average brand visibility across AI models for this topic is ',
  site: 'Site',
  mentioned: 'Mentioned in % of responses',
  yourMainCompetitors: 'Your Main Competitors in This Topic '
};

export const AiModelAnalysisFilterOptions = [
  `“Squarespace SEO”`,
  `“Lightweight running shoes for long distances”`,
  `“Long distances”`,
  `“Running shoes”`
];

// ---------- Static Data ----------
export const competitorSites = [
  { url: 'https://neilpatel.com/', percent: '88.5%' },
  { url: 'www.squarespace.com/', percent: '82.5%' },
  { url: 'https://www.clickminded.com/', percent: '81.5%' },
  { url: 'https://www.katescott.co/', percent: '80.5%' },
  { url: 'www.semrush.com/', percent: '77%' }
];

export const TopPromptsData = [
  {
    id: 1,
    prompt: 'How do I improve SEO on my Squarespace site?',
    actionText: 'View Response'
  },
  {
    id: 2,
    prompt: 'Is Squarespace good for SEO?',
    actionText: 'View Response'
  },
  {
    id: 3,
    prompt: 'How do I get my Squarespace site to show up on Google?',
    actionText: 'View Response'
  },
  {
    id: 4,
    prompt: 'Best SEO settings for Squarespace',
    actionText: 'View Response'
  },
  {
    id: 5,
    prompt: 'How to add meta tags in Squarespace',
    actionText: 'View Response'
  },
  {
    id: 6,
    prompt: 'Squarespace alternative for better SEO performance',
    actionText: 'View Response'
  },
  {
    id: 7,
    prompt: 'How to verify Squarespace site with Google Search Console',
    actionText: 'View Response'
  },
  {
    id: 8,
    prompt: 'Squarespace vs Wordpress for SEO rankings',
    actionText: 'View Response'
  },
  {
    id: 9,
    prompt: 'Sitemap submission for Squarespace',
    actionText: 'View Response'
  },
  {
    id: 10,
    prompt: 'Does Squarespace affect page speed and SEO?',
    actionText: 'View Response'
  }
];

export const BoostTopicVisibilitySteps = [
  {
    id: 'expand-topic-coverage',
    title: 'Expand Topic Coverage',
    img: 'expand',
    desc: 'Create content that directly answers popular prompts in your topic.'
  },
  {
    id: 'increase-authority-signals',
    title: 'Increase Authority Signals',
    img: 'authority',
    desc: 'Earn mentions and backlinks from authoritative sites in your niche.'
  },
  {
    id: 'optimize-topic-relevance',
    title: 'Optimize Topic Relevance',
    img: 'relevance',
    desc: 'Align your brand messaging and metadata with target topic keywords.'
  },
  {
    id: 'monitor-competitors',
    title: 'Monitor Competitors',
    img: 'competitors',
    desc: 'Track how competitors appear in AI and highlight your unique value.'
  }
  //{
  //  title: 'Leverage Structured Data',
  //  desc: 'Implement schema markup to help AI models better understand your content context.'
  //},
  //{
  //  title: 'Enhance Content Freshness',
  //  desc: 'Regularly update key pages and insights to stay aligned with evolving AI trends.'
  //},
  //{
  //  title: 'Boost Engagement Signals',
  //  desc: 'Encourage user interactions like clicks, shares, and dwell time to signal relevance.'
  //},
  //{
  //  title: 'Diversify Content Formats',
  //  desc: 'Incorporate visuals, videos, and FAQs to improve topical depth and discoverability.'
  //}
];

export const WantBetterAIMentionsSteps = [
  {
    id: 'check-source-mentions',
    title: 'Check Source Mentions',
    img: 'check-mentions',
    desc: 'Ensure your brand is listed in trusted directories and media so AI has authoritative references.'
  },
  {
    id: 'keep-content-fresh',
    title: 'Keep Content Fresh',
    img: 'keep-fresh',
    desc: 'Regularly update your website and business profiles to prevent AI from pulling outdated information.'
  },
  {
    id: 'optimize-entity-signals',
    title: 'Optimize Entity Signals',
    img: 'entity-signals',
    isComingSoon: true,
    desc: 'Add structured data, clear brand descriptions, and consistent naming across the web.'
  },
  {
    id: 'build-positive-reputation',
    title: 'Build Positive Reputation',
    img: 'reputation',
    desc: 'Encourage reviews, case studies, and testimonials to shape AI’s sentiment about your brand.'
  }
  //{
  //  title: 'Strengthen Brand Associations',
  //  desc: 'Collaborate with industry leaders and appear alongside reputable entities to reinforce topical authority.'
  //},
  //{
  //  title: 'Align Messaging Across Channels',
  //  desc: 'Ensure your tone, keywords, and descriptions match across your website, LinkedIn, and other platforms.'
  //},
  //{
  //  title: 'Monitor AI Mentions Regularly',
  //  desc: 'Track how AI models describe your brand to identify gaps, biases, or outdated perceptions.'
  //},
  //{
  //  title: 'Publish High-Expertise Content',
  //  desc: 'Demonstrate subject-matter authority through detailed, insight-driven content that AI can reference confidently.'
  //}
];

export const ellipsisStyle = `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`;

export const AiVisibilityVTutorialLink =
  'https://www.youtube.com/watch?v=5pKkp7GJgBs';

export const AIVisibilityAddOnModalWidth = '600px';